[
    {
        "key": "1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 5,
                "y": 7,
                "key": "keslV"
            },
            {
                "x": 5,
                "y": 5,
                "key": "JNY9d"
            },
            {
                "x": 6,
                "y": 5,
                "key": "_pCyU"
            },
            {
                "x": 6,
                "y": 3,
                "key": "tLpRoiW2EvVrLyND4pBYF"
            },
            {
                "x": 10,
                "y": 3,
                "key": "SbR3N"
            },
            {
                "x": 10,
                "y": 5,
                "key": "NNWms"
            },
            {
                "x": 11,
                "y": 5,
                "key": "cKYM0"
            },
            {
                "x": 11,
                "y": 7,
                "key": "1MYk2"
            },
            {
                "x": 10,
                "y": 7,
                "key": "-l9Xq"
            },
            {
                "x": 10,
                "y": 8,
                "key": "rEt0b"
            },
            {
                "x": 6,
                "y": 8,
                "key": "dyYPS"
            },
            {
                "x": 6,
                "y": 7,
                "key": "stOEn_4Hof8z7g2cDFKPY"
            }
        ]
    }
]